import './PeriscopeSource.scss';
import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { ArovyLogo } from './ArovyLogo';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { SalesforceLogo } from './SalesforceLogo';
import { Tooltip } from 'antd';
import { useAmplitude } from '@hooks';
import React, { useCallback } from 'react';
const sourceIcons = {
    [ORGANIZATION_TYPE_LABELS.PARDOT]: SalesforceLogo,
    [ORGANIZATION_TYPE_LABELS.SALESFORCE]: SalesforceLogo,
    [ORGANIZATION_TYPE_LABELS.SONAR]: ArovyLogo
};
export const PeriscopeSource = ({ iconColor, id, sonarObjectType, url }) => {
    const logAnalyticEvent = useAmplitude();
    const sourceLabel = getSonarObjectTypeSourceLabel(sonarObjectType);
    const Icon = sourceIcons[sourceLabel];
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        logAnalyticEvent({
            data: { objectType: sonarObjectType },
            id: AMPLITUDE_EVENT.SALESFORCE_URL_CLICKED
        });
    }, [logAnalyticEvent, sonarObjectType]);
    const iconBase = React.createElement(Icon, { color: iconColor, title: '' });
    const iconDisplay = url ?
        React.createElement("a", { href: url, id: id, onClick: handleClick, target: '_blank', title: sourceLabel }, iconBase) :
        iconBase;
    return (React.createElement("div", { className: 'periscope-source' },
        React.createElement(Tooltip, { placement: 'bottom', title: sourceLabel }, iconDisplay)));
};
